import { render } from "./Loader.vue?vue&type=template&id=e04d0030"
import script from "./Loader.vue?vue&type=script&lang=js"
export * from "./Loader.vue?vue&type=script&lang=js"

import "./Loader.vue?vue&type=style&index=0&id=e04d0030&lang=scss"
script.render = render

export default script